import { Button, Card, CardActions, CardContent, CardHeader, Grid, LinearProgress, Typography } from "@mui/material";
import { intersection, orderBy } from "lodash";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import CardImage from "./CardImage";
import { filterPackages } from "./filterPackages";
import type { ListPublicPackagesResponseItem } from "./publicPackagesApi";
import { usePublicPackages } from "./usePublicPackages";

const SimilarPackage: FC<{ value: ListPublicPackagesResponseItem }> = ({ value }) => {
  const navigate = useNavigate();
  return (
    <Card style={{ display: "flex", justifyContent: "space-between", flexDirection: "column" }}>
      <CardHeader title={<Typography variant="h6">{value.name}</Typography>} subheader={value.packageName} />
      <CardContent />
      <CardImage image={value.images.at(0)} />
      <CardActions>
        <Button
          variant="outlined"
          size="small"
          fullWidth
          onClick={() => navigate(`/public/packages/${value.id.id}`)}
          color="primary"
        >
          Zobacz szczegóły
        </Button>
      </CardActions>
    </Card>
  );
};

function sortPackagesByMatchingTagsDesc(matchingPackages: ListPublicPackagesResponseItem[], groupTypeTags: Tag[]) {
  // TODO
  return orderBy(matchingPackages, (p) => intersection(p.tags, groupTypeTags).length, "desc");
}

interface Tag {
  readonly category: string;
  readonly value: string;
}

interface Props {
  readonly groupTypeTags: Tag[];
  readonly maxItems: number;
  readonly currentPackageId: string;
}

const SimilarPackages: FC<Props> = ({ groupTypeTags, maxItems, currentPackageId }) => {
  const { packages, isLoading } = usePublicPackages();
  const matchingPackages = filterPackages(packages, groupTypeTags).filter((p) => p.id.id !== currentPackageId);
  const sortedMatchingPackages = sortPackagesByMatchingTagsDesc(matchingPackages, groupTypeTags).slice(0, maxItems);

  if (isLoading) {
    return <LinearProgress />;
  }
  if (sortedMatchingPackages.length === 0) {
    return null;
  }
  return (
    <>
      <Grid size={12}>
        <Typography variant="h6">Objerzyj inne propozycje wycieczek dla Twoich klientów</Typography>
      </Grid>
      {sortedMatchingPackages.map((p) => (
        <Grid size={12 / maxItems} key={p.id.id} style={{ display: "flex" }}>
          <SimilarPackage value={p} />
        </Grid>
      ))}
    </>
  );
};

export default SimilarPackages;
